import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter } from "react-router";
import Footer from "./components/Footer";
import ButtonHome from "./components/ButtonHome";
import ButtonProfile from "./components/ButtonProfile";
import AppRoutes_ from "./routes/AppRoutes_";

export default function App() {
  return (
    <BrowserRouter>
      <div className="container-app">
        <ButtonHome />
        <ButtonProfile />
        <AppRoutes />
        {/* <AppRoutes_ /> */}
        <Footer />
      </div>
    </BrowserRouter>
  );
}
